import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PageWrapper } from 'components-antd';
import { LocalHeader } from './components/LocalHeader';
import { Content } from './components/Content';
import { requestGetSymphonyPreferencesEffect, requestGetSymphonyStatsEffect } from 'store/effects';
import {
  getSymphonyColumns,
  getSymphonyPreferencesData,
  getSymphonyStatsData,
} from 'store/selectors/symphony';
import styles from './styles.module.scss';
import { getSelectedParams } from './components/Columns/helpers';
import { getFormMetaEffect } from 'store/effects/formProcess';

export const Symphony = () => {
  const dispatch = useDispatch();
  const { stats, isIdle, isPending } = useSelector(getSymphonyStatsData);
  const { isPending: preferencesIsPending } = useSelector(getSymphonyPreferencesData);

  const selectedColumns = useSelector(getSymphonyColumns);
  const [tableData, setTableData] = useState<any[]>([]);

  const fetchTeamList = () =>
    dispatch(
      requestGetSymphonyStatsEffect(
        { isActive: true, ...getSelectedParams(selectedColumns) },
        { silent: !isIdle },
      ),
    );

  useEffect(() => {
    dispatch(getFormMetaEffect());
    dispatch(requestGetSymphonyPreferencesEffect());
  }, []);

  useEffect(() => {
    fetchTeamList();
  }, [selectedColumns]);

  useEffect(() => {
    setTableData(stats);
  }, [stats]);

  return (
    <PageWrapper
      version={2}
      mainPageContentStyle={styles.mainPageContent}
      pageContentClassName={styles.pageContent}
    >
      <LocalHeader />
      <Content data={tableData} isPending={isPending || preferencesIsPending} />
    </PageWrapper>
  );
};
